class ImageProductSlider extends HTMLElement {
  connectedCallback() {
    if (this.swiper) return;

    const mobileRows =
      parseInt(this.dataset.mobileGridRows, 10) || 2;

    const scrollbarEl = this.querySelector(
      ".swiper-scrollbar-card"
    );

    const section = this.closest(".image-product-slider");

    const prevEl = section?.querySelector(
      ".image-product-slider__nav-prev"
    );

    const nextEl = section?.querySelector(
      ".image-product-slider__nav-next"
    );

    if (typeof window.Swiper !== "function") {
      console.warn("Swiper is not loaded.");
      return;
    }

    this.swiper = new window.Swiper(this, {
      grabCursor: true,
      watchOverflow: true,

      mousewheel: {
        forceToAxis: true,
      },

      navigation: {
        prevEl,
        nextEl,
      },

      scrollbar: {
        el: scrollbarEl,
        draggable: true,
      },

      breakpoints: {
        0: {
          slidesPerView: 2,
          spaceBetween: 10,
          freeMode: false,
          grid: {
            rows: mobileRows,
            fill: "row",
          },
        },

        750: {
          slidesPerView: 2,
          spaceBetween: 16,
          freeMode: true,
          grid: {
            rows: 1,
          },
        },

        1100: {
          slidesPerView: 4,
          spaceBetween: 16,
          freeMode: true,
          grid: {
            rows: 1,
          },
        },
      },
    });
  }

  disconnectedCallback() {
    this.swiper?.destroy(true, true);
  }
}

if (!customElements.get("image-product-slider")) {
  customElements.define(
    "image-product-slider",
    ImageProductSlider
  );
}
